<template>
  <div>
    <div class="content-section__filter">
      <custom-select
        v-if="filters.targetAudience.length > 0"
        :data-array="filters.targetAudience"
        v-model="selectedFilters.targetAudience"
      >
      </custom-select>
      <custom-select
        v-if="filters.places.length > 0"
        :data-array="filters.places"
        v-model="selectedFilters.place"
      >
      </custom-select>
    </div>
    <div class="grid">
      <list-item :item="item" v-for="item in items" :key="item.id"></list-item>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExcursionsList",
  props: {
    items: {
      type: Array,
      default() {
        return [{
          id: 0,
          detailPageUrl: '',
          detailPicture: {
            src: '',
          },
          name: '',
          targetAudience: {
            value: [],
          },
          duration: {
            value: '',
          },
        }];
      },
    },
    filters: {
      type: Object,
      default() {
        return {
          places: [{text: 'по всем адресам', value: 'all'}, {text: 'Другое', value: 'other'}],
          targetAudience: [{text: 'для любой аудитории', value: 'all'}, {text: 'Другое', value: 'other'}],
        };
      },
    },
  },
  components: {
    CustomSelect: () => import('./../CustomSelect'),
    ListItem: () => import('./ListItem'),
  },
  data() {
    const params = (new URL(document.location)).searchParams;

    return {
      selectedFilters: {
        place: params.get('place') ?? 'all',
        targetAudience: params.get('targetAudience') ?? 'all',
      },
      ready: false,
    }
  },
  mounted() {
  },
  watch: {
    selectedFilters: {
      handler(val) {
        const params = new URLSearchParams(location.search.substring(1));

        if (val.place !== undefined && val.place !== 'all')
          params.set('place', val.place);
        else
          params.delete('place');

        if (val.targetAudience !== undefined && val.targetAudience !== 'all')
          params.set('targetAudience', val.targetAudience);
        else
          params.delete('targetAudience');

        location.search = params.toString();
      },
      deep: true,
    }
  }
}
</script>
